import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import LockIcon from '@mui/icons-material/Lock';

export default function CTASection() {
  const navigate = useNavigate();

  return (
    <Box 
      id="ctaSection"
      component="section" 
      sx={{ 
        py: { xs: 6, md: 10 },
        backgroundColor: 'background.paper',
        textAlign: 'center'
      }}
    >
      <Container maxWidth="md">
        <Typography variant="h3" component="h2" gutterBottom>
          Take control of your dividend strategy today!
        </Typography>
        <Typography variant="h5" color="text.secondary" sx={{ mb: 4 }}>
          Join thousands of investors making smarter dividend decisions
        </Typography>
        <Box sx={{ mb: 4 }}>
          <Button 
            variant="contained" 
            size="large"
            sx={{ mr: 2 }}
            onClick={() => navigate('/signup/premium')}
          >
            Start Scoring My Portfolio
          </Button>

        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
          <LockIcon fontSize="small" />
          Secure & Private | Trusted by Thousands
        </Typography>
      </Container>
    </Box>
  );
}
